import React from 'react'

import ShareTab from '../../../share-tab'

const TrackShareTab = props => {
  return <ShareTab shareType="track" {...props} />
}

export default TrackShareTab
